
import Vue from 'vue';

export default Vue.extend({
  name: 'SliderTextImageEntry',
  props: {
    image: {
      type: [Array, Object],
    },
    heading: {
      type: String,
      default: null,
    },
    subheading: {
      type: String,
      default: null,
    },
    button: {
      type: [Array, Object],
    },
    text: {
      type: [Array, Object],
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    slide: {
      type: [Array, Object],
    },
  },
});
